export default __webpack_public_path__ + "static/media/nf.694c577f.jpg";